import React, { useRef } from 'react'
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { AiFillMedicineBox } from 'react-icons/ai';
import { IoIosText, IoLogoWhatsapp } from 'react-icons/io';
import { MdAdd, MdEmail } from 'react-icons/md';
import { Button, Form, Modal } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { HiPlusCircle } from "react-icons/hi";
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { getAllMedicine, searchMedicine, addMedicine, viewMedicine, deleteMedicine, updateMedicine } from '../../../redux/actions/Feedback.action';
import { PiWarningCircleBold } from 'react-icons/pi';
import { useNavigate, useParams } from 'react-router-dom';
import { medicinePackage, medicinePrint } from '../../../redux/actions/Doctor.action';
import { FiTarget } from 'react-icons/fi';
import MedicineBill from '../medicineBill/MedicineBill';

const MedicinesCard = ({ patientIds }) => {

    const { id } = useParams()
    const navigate = useNavigate()
    const billRef = useRef();
    const [show, setShow] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [medicineId, setMedicineId] = useState();
    const [editingId, setEditingId] = useState(null);
    const [editingField, setEditingField] = useState(null);
    const [selectedMedicines1, setSelectedMedicines1] = useState([]);
    const [activeView, setActiveView] = useState('viewAll');
    const [activeView1, setActiveView1] = useState('oldMedicine');
    const [selectedPackage1, setSelectedPackage1] = useState([])

    const toggle = () => {
        setShow(!show)
        if (show) {
            setSelectedMedicines([]);
            setIds([]);
        }
    }
    const deleteToggle = () => { setDeleteModal(!deleteModal) }
    const viewToggle = () => { setViewModal(!viewModal) }
    const dispatch = useDispatch();
    const diagnosisDatas = useSelector((state) => state.master)
    const medicineData = useSelector((state) => state.feedback)
    console.log('medicineData',medicineData);
    const packageData = useSelector((state) => state.doctor)

    const [allMedicine, setAllMedicine] = useState()
    const [diagnosisData, setDiagnosisData] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        search: '',
    });
    const [ids, setIds] = useState([])
    const [medicineData1, setMedicineData1] = useState({
        medicinename: '',
    });
    const [selectedMedicines, setSelectedMedicines] = useState([]);
    const initialValues = {
        treatmentName: '',
    }

    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(4);

    const [formData, setFormData] = useState({})

    const validationSchema = Yup.object().shape({
        treatmentName: Yup.string().required('Medicine is required')
    });

    const mainId = medicineData?.viewMedicine?.data?.patientMedicin?._id
    const authId = medicineData?.viewMedicine?.data?.patientMedicin
    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        medicineData?.viewMedicine?.data?.totalCount / postPerPage,
    );
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    }

    const handleInputChange = (e, field) => {
        setFormData({ ...formData, [field]: e.target.value });
    };

    const handleEditClick = (id, field) => {
        setEditingId(id);
        setEditingField(field);

        const row = medicineData.viewMedicine.data.patientMedicin.medicin.find((med) => med._id === id);
        setFormData({
            medicinName: row.medicinName,
            dose: row.dose,
            qty: row.qty,
            remark: row.remark,
        });
    };

    const handleKeyDown = async (e, id) => {
        if (e.key === 'Enter') {
            try {
                const payload = {
                    medicinId: id,
                    medicinName: formData.medicinName,
                    dose: formData.dose,
                    qty: formData.qty,
                    remark: formData.remark,
                };
                await dispatch(updateMedicine(mainId, payload, patientIds, limits));
                setEditingId(null);
                setEditingField(null);
            } catch (error) {
                console.error('Error updating medicine:', error);
            }
        }
    };

    const handleBlur = async (id) => {
        try {
            const payload = {
                medicinId: id,
                medicinName: formData.medicinName,
                dose: formData.dose,
                qty: formData.qty,
                remark: formData.remark,
            };
            await dispatch(updateMedicine(mainId, payload, patientIds, limits));
            setEditingId(null);
            setEditingField(null);
        } catch (error) {
            console.error('Error updating medicine:', error);
        }
    };


    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const addMedicines = (values) => {
        const currentMedicine = values.treatmentName;
        const medicineId = values.selectedMedicineId;

        if (currentMedicine && medicineId) {
            const exists = selectedMedicines.some(med => med.id === medicineId);

            if (!exists) {
                setSelectedMedicines(prev => [...prev, { id: medicineId, name: currentMedicine }]);
            }
        }

        setIds(prev => {
            if (!prev.includes(medicineId)) {
                return [...prev, medicineId];
            }
            return prev;
        });
    };

    useEffect(() => {
        console.log('Updated ids:', ids);
    }, [ids]);


    const searchData = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || ''
        };
        setSearchDefault(newSearchParams);
        dispatch(searchMedicine(newSearchQuery))
    };

    const handleAdd = (values) => {
        const payload = {
            patientId: patientIds,
            medicineIds: ids,
        };
        dispatch(addMedicine(payload, patientIds, limits)).then(() => {
            toggle();
        });
    };
    

    const handleDelete = () => {
        const payload = {
            deleteMedicinId: medicineId
        }
        dispatch(deleteMedicine(limits, patientIds, payload, mainId)).then(() => {
            deleteToggle()
            setMainPage(1);
        })
    }

    const handleCheckboxChange = (e, medicineId) => {
        if (e.target.checked) {
            setSelectedMedicines1((prev) => [...prev, medicineId]);
        } else {
            setSelectedMedicines1((prev) => prev.filter((id) => id !== medicineId));
        }
    };

    const handleAddMedicineClick = () => {
        const selectedMedicineNames = medicineData?.viewMedicine?.data?.patientMedicin?.medicin
            ?.filter(med => selectedMedicines1.includes(med._id))
            ?.map(med => med.medicinName);
    
        const payload = {
            patientId: patientIds,
            medicineNames: selectedMedicineNames,
        };
    
        dispatch(addMedicine(payload, patientIds, limits)).then(() => {
            setSelectedMedicines1([]);
            toggle();
        });
    };
    

    const handleGenerateSlipClick = (res) => {

        const allMedicineIds = res?.medicines?.map((medicine) => medicine._id);
        const filteredMedicineIds = allMedicineIds.filter((id) => selectedPackage1.includes(id));

        const payload = {
            medIds: filteredMedicineIds.length > 0 ? filteredMedicineIds : allMedicineIds
        };

        dispatch(medicinePrint(patientIds, payload)).then(() => {
            const newWindow = window.open('', '_blank');
            newWindow.document.write(`
                <html>
                    <head>
                        <title>Medicine</title>
                        <style>
                            @media print {
                                body {
                                    margin: 0;
                                    padding: 0;
                                    background-color: #fff;
                                    font-family: "Arial, sans-serif",
                                }
                                .content {
                                    width: 100%;
                                    max-width: 595pt;
                                    height: 100%;
                                    margin: 0 auto;
                                    box-sizing: border-box;
                                    overflow: hidden;
                                }
                                .content table {
                                    width: 100%;
                                    border-collapse: collapse;
                                }
                                .content table, .content th, .content td {
                                    page-break-inside: avoid;
                                }
                                .content * {
                                    font-size: 14px;
                                }
                                .content div, .content p, .content span {
                                    page-break-inside: avoid;
                                }
                            }
                            .content {
                                transform: scale(0.95);
                                transform-origin: top left;
                            }
                        </style>
                    </head>
                    <body>
                        <div class="content">
                            ${billRef.current.innerHTML}
                        </div>
                    </body>
                </html>
            `);

            newWindow.document.close();

            newWindow.onload = () => {
                newWindow.print();
                newWindow.onafterprint = () => {
                    newWindow.close();
                };
            };
        })
        localStorage.setItem('selectedPackage1', JSON.stringify(payload));
        localStorage.setItem('patientIds', patientIds)
    };

    useEffect(() => {
        console.log('Updated selectedPackage1:', selectedPackage1);
    }, [selectedPackage1]);

    useEffect(() => {
        dispatch(getAllMedicine())
        dispatch(medicinePackage(patientIds))
        if (patientIds) {
            dispatch(viewMedicine(patientIds, limits))
        }
    }, [patientIds, mainPage, rowsPerPage])

    const handleCheckboxChanges1 = (medicineId) => {
        setSelectedPackage1((prevSelected) => {
            if (prevSelected.includes(medicineId)) {
                return prevSelected.filter((id) => id !== medicineId);
            } else {
                return [...prevSelected, medicineId];
            }
        });
    };

    useEffect(() => {
        if (allMedicine?.medicines?.length > 0) {
            const allMedicineIds = allMedicine.medicines.map((medicine) => medicine._id);
            setSelectedPackage1(allMedicineIds);
        }
    }, [allMedicine])

    const handleSave = () => {
        setSelectedPackage1(selectedPackage1)
        viewToggle()
    }

    return (
        <div>
            <div className="row">
                <div className='col-12'>
                    <div className="!bg-[#fff] shadow p-4 rounded-4 mt-3">
                        <div className="d-flex justify-between">
                            <div className="flex gap-3 mt-3">
                                <AiFillMedicineBox className="fs-5" />
                                <h6>Medicines</h6>
                            </div>

                            <div className="flex gap-3">
                                {/* {selectedMedicines1.length > 0 && (
                                    <div className="flex gap-3">
                                        <div className="">
                                            <Button className="!bg-theme-dark !border-none d-flex gap-1" onClick={handleGenerateSlipClick}>
                                                Generate Slip
                                            </Button>
                                        </div>
                                        <div className="">
                                            <Button className="!bg-theme-dark !border-none d-flex gap-1" onClick={handleAddMedicineClick}>
                                                Add Medicine
                                            </Button>
                                        </div>
                                    </div>
                                )} */}
                                <div className="">
                                    <Button onClick={toggle} className="!bg-theme-dark !border-none d-flex gap-1">
                                        Add New <MdAdd className="fs-4  fw-bold" />
                                    </Button>
                                </div>
                            </div>
                        </div>

                        <div className='flex gap-3 mt-3'>
                            <div className="border-r pe-3">
                                <Button
                                    className={`!bg-theme-dark !border-theme-dark ${activeView === 'viewAll' ? '' : '!bg-transparent !text-theme-dark'}`} // Highlight active button
                                    onClick={() => setActiveView('viewAll')} >
                                    View All
                                </Button>
                            </div>
                            <div className="">
                                <Button
                                    className={`!border-theme-dark ${activeView === 'dateWise' ? '!bg-theme-dark !text-white' : '!bg-transparent !text-theme-dark'}`} // Highlight active button
                                    onClick={() => setActiveView('dateWise')}>
                                    Date Wise
                                </Button>
                            </div>
                        </div>

                        <div className="mt-3">
                            {activeView === 'viewAll' && (
                                <TableContainer>
                                    <Table className="table-bordered">
                                        <Thead className="!bg-theme-dark text-center">
                                            <Tr>
                                                {/* <Th></Th> */}
                                                <Th className="!text-white">Date</Th>
                                                <Th className="!text-white">Medicine</Th>
                                                <Th className="!text-white">Dose</Th>
                                                <Th className="!text-white">Qty</Th>
                                                <Th className="!text-white">Remark</Th>
                                                <Th className="!text-white">User</Th>
                                                <Th className="!text-white">Action</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody className="">
                                            {medicineData?.viewMedicine?.data?.patientMedicin?.medicin?.length > 0 ? (
                                                medicineData?.viewMedicine?.data?.patientMedicin?.medicin?.map((res) => (
                                                    <Tr key={res._id}>
                                                        {/* <Td>
                                                        <Form.Check
                                                            type="checkbox"
                                                            onChange={() => handleCheckboxChange(res?.medId, res._id)}
                                                            checked={selectedMedicines1.includes(res?.medId, res._id)}
                                                        />
                                                    </Td> */}
                                                        {/* <Td>{new Date(res.Date).toLocaleDateString()}</Td> */}
                                                        <Td>{new Date(res.createdAt).toLocaleDateString()}</Td>
                                                        <Td onClick={() => handleEditClick(res._id, 'medicinName')}>
                                                            {editingId === res._id && editingField === 'medicinName' ? (
                                                                <input
                                                                    value={formData.medicinName}
                                                                    onChange={(e) => handleInputChange(e, 'medicinName')}
                                                                    onKeyDown={(e) => handleKeyDown(e, res._id)}
                                                                    onBlur={() => handleBlur(res._id)}
                                                                    autoFocus
                                                                />
                                                            ) : (
                                                                res.medicinName
                                                            )}
                                                        </Td>
                                                        <Td onClick={() => handleEditClick(res._id, 'dose')}>
                                                            {editingId === res._id && editingField === 'dose' ? (
                                                                <input
                                                                    value={formData.dose}
                                                                    onChange={(e) => handleInputChange(e, 'dose')}
                                                                    onKeyDown={(e) => handleKeyDown(e, res._id)}
                                                                    onBlur={() => handleBlur(res._id)}
                                                                    autoFocus
                                                                />
                                                            ) : (
                                                                res.dose
                                                            )}
                                                        </Td>

                                                        <Td onClick={() => handleEditClick(res._id, 'qty')}>
                                                            {editingId === res._id && editingField === 'qty' ? (
                                                                <input
                                                                    value={formData.qty}
                                                                    onChange={(e) => handleInputChange(e, 'qty')}
                                                                    onKeyDown={(e) => handleKeyDown(e, res._id)}
                                                                    onBlur={() => handleBlur(res._id)}
                                                                    autoFocus
                                                                />
                                                            ) : (
                                                                res.qty
                                                            )}
                                                        </Td>
                                                        <Td onClick={() => handleEditClick(res._id, 'remark')}>
                                                            {editingId === res._id && editingField === 'remark' ? (
                                                                <input
                                                                    value={formData.remark}
                                                                    onChange={(e) => handleInputChange(e, 'remark')}
                                                                    onKeyDown={(e) => handleKeyDown(e, res._id)}
                                                                    onBlur={() => handleBlur(res._id)}
                                                                    autoFocus
                                                                />
                                                            ) : (
                                                                res.remark
                                                            )}
                                                        </Td>
                                                        <Td>{authId?.medicinAddedBy}</Td>
                                                        <Td>
                                                            <div className='flex items-center gap-3'>

                                                                <MdDelete className="text-danger cursor-pointer" title="delete"
                                                                    onClick={() => {
                                                                        deleteToggle();
                                                                        setMedicineId(res?._id);
                                                                    }}
                                                                />
                                                            </div>
                                                        </Td>
                                                    </Tr>
                                                ))
                                            ) : (
                                                <Tr>
                                                    <Td colSpan={6} textAlign="center">
                                                        No any medicine
                                                    </Td>
                                                </Tr>
                                            )}
                                        </Tbody>
                                    </Table>
                                </TableContainer>
                            )}

                            {activeView === 'dateWise' && (
                                <TableContainer>
                                    <Table className="table-bordered">
                                        <Thead className="!bg-theme-dark text-center">
                                            <Tr>
                                                <Th className="!text-white">Date</Th>
                                                <Th className="!text-white">Total Medicine</Th>
                                                <Th className="!text-white">Action</Th>
                                                <Th className="!text-white"></Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {
                                                packageData?.medicinePackage?.data?.data?.length > 0 ? (
                                                    packageData?.medicinePackage?.data?.data?.map((res) => {
                                                        return (
                                                            <Tr key={res._id}>
                                                                <Td>
                                                                    {new Intl.DateTimeFormat('en-GB', {
                                                                        day: '2-digit',
                                                                        month: '2-digit',
                                                                        year: 'numeric',
                                                                    }).format(new Date(res.date))}
                                                                </Td>
                                                                <Td>{res.medicines?.length}</Td>
                                                                <Td><FiTarget className='text-primary text-xl' title='view' onClick={() => { viewToggle(); setAllMedicine(res) }} /></Td>
                                                                <Td>
                                                                    <Button className="!bg-theme-dark !border-none d-flex px-3 gap-1" onClick={() => { handleGenerateSlipClick(res); }}>
                                                                        Print
                                                                    </Button>
                                                                </Td>
                                                            </Tr>
                                                        )
                                                    })
                                                ) : (
                                                    <Tr>
                                                        <Td colSpan={6} textAlign="center">
                                                            No any medicine
                                                        </Td>
                                                    </Tr>
                                                )
                                            }
                                        </Tbody>
                                    </Table>
                                </TableContainer>
                            )}
                        </div>
                        <div className="flex justify-between items-center mt-2 text-sm">
                            <div>
                                Rows per page:
                                <select
                                    value={rowsPerPage}
                                    onChange={handleRowsPerPageChange}
                                    className="ms-2 border rounded-md focus:outline-none"
                                >
                                    <option value="">Select</option>
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={30}>30</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>

                            <ReactPaginate
                                breakLabel="..."
                                nextLabel=" >"
                                onPageChange={ChangeMainPage}
                                pageRangeDisplayed={5}
                                pageCount={PageCount}
                                previousLabel="< "
                                renderOnZeroPageCount={null}
                                className="pagination"
                            />
                        </div>
                    </div>
                </div>
            </div >

            {/* Add */}
            <Modal Modal show={show} onHide={toggle} size='lg' >
                <Modal.Header closeButton>
                    <Modal.Title>Add Medicine</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAdd}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>

                                <div className='flex gap-3 mb-3'>
                                    <div className="border-r pe-3">
                                        <Button
                                            className={`!bg-theme-dark !border-theme-dark ${activeView1 === 'oldMedicine' ? '' : '!bg-transparent !text-theme-dark'}`}
                                            onClick={() => setActiveView1('oldMedicine')} >
                                            Old Medicine
                                        </Button>
                                    </div>
                                    <div className="">
                                        <Button
                                            className={`!border-theme-dark ${activeView1 === 'newMedicine' ? '!bg-theme-dark !text-white' : '!bg-transparent !text-theme-dark'}`}
                                            onClick={() => setActiveView1('newMedicine')}>
                                            New Medicine
                                        </Button>
                                    </div>
                                </div>
                                {activeView1 === 'oldMedicine' && (
                                    <>
                                        <TableContainer>
                                            <Table className="table-bordered">
                                                <Thead className="!bg-theme-dark text-center">
                                                    <Tr>
                                                        <Th></Th>
                                                        <Th className="!text-white">Date</Th>
                                                        <Th className="!text-white">Medicine</Th>
                                                        <Th className="!text-white">Dose</Th>
                                                        <Th className="!text-white">Qty</Th>
                                                        <Th className="!text-white">Remark</Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {medicineData?.viewMedicine?.data?.patientMedicin?.medicin?.length > 0 ? (
                                                        medicineData?.viewMedicine?.data?.patientMedicin?.medicin?.map((res) => {
                                                            return (
                                                                <>
                                                                    <Tr key={res._id}>
                                                                        <Td>
                                                                            <Form.Check
                                                                                type="checkbox"
                                                                                onChange={(e) => handleCheckboxChange(e, res?._id)}
                                                                                checked={selectedMedicines1.includes(res?._id)}
                                                                            />
                                                                        </Td>
                                                                        <Td>{new Date(res.createdAt).toLocaleDateString()}</Td>
                                                                        <Td>{res.medicinName}</Td>
                                                                        <Td>{res.dose}</Td>
                                                                        <Td>{res.qty}</Td>
                                                                        <Td>{res.remark}</Td>
                                                                    </Tr>
                                                                </>
                                                            )
                                                        })
                                                    ) : (
                                                        <Tr>
                                                            <Td colSpan={4} textAlign="center">
                                                                No any medicine
                                                            </Td>
                                                        </Tr>
                                                    )
                                                    }
                                                </Tbody>
                                            </Table>
                                        </TableContainer>
                                        <div className="flex justify-between items-center mt-2">
                                            <div>
                                                Rows per page:
                                                <select
                                                    value={rowsPerPage}
                                                    onChange={handleRowsPerPageChange}
                                                    className="ms-2 border rounded-md focus:outline-none"
                                                >
                                                    <option value="">Select</option>
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={30}>30</option>
                                                    <option value={50}>50</option>
                                                </select>
                                            </div>

                                            <ReactPaginate
                                                breakLabel="..."
                                                nextLabel=" >"
                                                onPageChange={ChangeMainPage}
                                                pageRangeDisplayed={5}
                                                pageCount={PageCount}
                                                previousLabel="< "
                                                renderOnZeroPageCount={null}
                                                className="pagination"
                                            />
                                        </div>
                                    </>
                                )}

                                {activeView1 === 'newMedicine' && (
                                    <div className="row">
                                        <div className="col-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Medicines</Form.Label>
                                                <div className="relative flex items-center">
                                                    <input
                                                        name="treatmentName"
                                                        placeholder={values.treatmentName || 'Select Medicine'}
                                                        value={values.treatmentName}
                                                        readOnly
                                                        className="border w-full cursor-pointer outline-none border-theme-dark rounded py-[6px] px-[12px]"
                                                        onClick={() => {
                                                            setDiagnosisData(!diagnosisData);
                                                        }}
                                                    />

                                                    <div
                                                        className={`${diagnosisData
                                                            ? 'opacity-100 visible'
                                                            : 'opacity-0 invisible'
                                                            } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                                                    >
                                                        <input
                                                            type="text"
                                                            name="search"
                                                            value={searchQuery}
                                                            placeholder={`Search Medicine`}
                                                            onChange={searchData}
                                                            className="w-full border p-2 rounded outline-none"
                                                        />
                                                        {medicineData?.getAllMedicine?.data?.medicine?.map((res) => (
                                                            <p
                                                                key={res._id}
                                                                onClick={() => {
                                                                    const medicineId = res._id;
                                                                    const currentMedicine = res.medicinename;

                                                                    setFieldValue('treatmentName', currentMedicine);
                                                                    setDiagnosisData(false);
                                                                    setSearchQuery('');
                                                                    setSearchDefault({ page: '', search: '' });

                                                                    setSelectedMedicines(prev => {
                                                                        const exists = prev.some(med => med.id === medicineId);
                                                                        if (!exists) {
                                                                            return [...prev, { id: medicineId, name: currentMedicine }];
                                                                        }
                                                                        return prev;
                                                                    });

                                                                    setIds(prev => {
                                                                        if (!prev.includes(medicineId)) {
                                                                            return [...prev, medicineId];
                                                                        }
                                                                        return prev;
                                                                    });
                                                                }}
                                                                className="text-gray-700 py-1 cursor-pointer"
                                                            >
                                                                {res.medicinename}
                                                            </p>
                                                        ))}
                                                    </div>
                                                </div>
                                                <ErrorMessage
                                                    name="treatmentName"
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-12">
                                            <ul>
                                                {selectedMedicines.map((med, index) => (
                                                    <li key={index} className="flex justify-between items-center text-gray-700">
                                                        {med.name}
                                                        <div
                                                            onClick={() => {
                                                                setSelectedMedicines(prev => prev.filter(item => item.id !== med.id));
                                                                setIds(prev => prev.filter(id => id !== med.id));
                                                            }}
                                                            className="text-red-500 ml-2 cursor-pointer"
                                                        >
                                                            <MdDelete />
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}


                            </Modal.Body>
                            {activeView1 === 'newMedicine' && (
                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        onClick={toggle}
                                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        type="submit"
                                        className="!bg-theme-dark border-0 px-4"
                                    >
                                        Add
                                    </Button>
                                </Modal.Footer>
                            )}
                        </Form>
                    )}
                </Formik>
                {activeView1 === 'oldMedicine' && (
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={toggle}
                            className="px-4 bg-transparent border-[1px] text-black border-green-color"
                        >
                            Close
                        </Button>
                        <Button
                            type="submit"
                            className="!bg-theme-dark border-0 px-4"
                            onClick={handleAddMedicineClick}
                        >
                            Add
                        </Button>
                    </Modal.Footer>
                )}
            </Modal >

            {/* delete */}
            <Modal Modal show={deleteModal} onHide={deleteToggle} >
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDelete}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal >

            {/* View */}
            <Modal Modal show={viewModal} onHide={viewToggle} size='lg' >
                <Modal.Header closeButton>
                    <Modal.Title>All Medicine</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <TableContainer>
                        <Table className="table-bordered">
                            <Thead className="!bg-theme-dark text-center">
                                <Tr>
                                    <Th></Th>
                                    <Th className="!text-white">Medicine</Th>
                                    <Th className="!text-white">Dose</Th>
                                    <Th className="!text-white">Qty</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {allMedicine?.medicines?.length > 0 ? (
                                    allMedicine?.medicines?.map((res) => {
                                        return (
                                            <>
                                                <Tr key={res._id}>
                                                    <Td>
                                                        <Form.Check
                                                            type="checkbox"
                                                            onChange={() => handleCheckboxChanges1(res._id)}
                                                            checked={selectedPackage1.includes(res._id)}
                                                        />
                                                    </Td>
                                                    <Td>{res.medicinName}</Td>
                                                    <Td>{res.dose}</Td>
                                                    <Td>{res.qty}</Td>
                                                </Tr>
                                            </>
                                        )
                                    })
                                ) : (
                                    <Tr>
                                        <Td colSpan={4} textAlign="center">
                                            No any medicine
                                        </Td>
                                    </Tr>
                                )
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={viewToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        Close
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={handleSave}
                        className="!bg-theme-dark border-0 px-4"
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal >

            <MedicineBill billRef={billRef} />
        </div >
    )
}

export default MedicinesCard